import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import { CircularProgress } from 'material-ui/Progress'
import Backdrop from 'material-ui/Modal/Backdrop'

import styles from 'styles/components/LoadingPage'

@withStyles(styles)
@observer
export default class LoadingPage extends Component {

  static propTypes = {
    visible: PropTypes.bool.isRequired
  }

  static defaultProps = {
    visible: false
  }

  render() {
    const { visible, classes } = this.props

    return visible && (
      <div className={ classes.root }>
        <Backdrop open={ visible } />
        <CircularProgress size={100} thickness={1} />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/LoadingPage.js